import { render } from "./EventPage.vue?vue&type=template&id=7d71e4e8&scoped=true"
import script from "./EventPage.vue?vue&type=script&lang=js"
export * from "./EventPage.vue?vue&type=script&lang=js"

import "./EventPage.vue?vue&type=style&index=0&id=7d71e4e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d71e4e8"]])

export default __exports__